import { render, staticRenderFns } from "./TratsPresentarEdicion.vue?vue&type=template&id=77bceca2&scoped=true"
import script from "./TratsPresentarEdicion.vue?vue&type=script&lang=js"
export * from "./TratsPresentarEdicion.vue?vue&type=script&lang=js"
import style0 from "./TratsPresentarEdicion.vue?vue&type=style&index=0&id=77bceca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bceca2",
  null
  
)

export default component.exports